module.exports = __webpack_public_path__ + "img/pey_33_halo.1ba59ba2.png";